import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';

interface BaseItemInvertOptionProps {
  isChecked: boolean;

  onToggleOption(): void;
}

export function BaseItemInvertOption({...props}: BaseItemInvertOptionProps): ReactElement<any> {
  return (
    <ContextualMenuToggleOption
      id="item-invert-contextual-options"
      label={window.i18next.t('pmwjs_invert')}
      isChecked={props.isChecked}
      onClick={(): void => {
        props.onToggleOption();
      }}
    />
  );
}
